import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=c8a261b2&scoped=true&"
import script from "./Partners.vue?vue&type=script&lang=js&"
export * from "./Partners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a261b2",
  null
  
)

export default component.exports